"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationValidationErrorCode = exports.assert = exports.PushNotificationError = void 0;
var PushNotificationError_1 = require("./PushNotificationError");
Object.defineProperty(exports, "PushNotificationError", { enumerable: true, get: function () { return PushNotificationError_1.PushNotificationError; } });
var errorHelpers_1 = require("./errorHelpers");
Object.defineProperty(exports, "assert", { enumerable: true, get: function () { return errorHelpers_1.assert; } });
Object.defineProperty(exports, "PushNotificationValidationErrorCode", { enumerable: true, get: function () { return errorHelpers_1.PushNotificationValidationErrorCode; } });
